/**
  @Time: 2023/08/25-11:35
 
  @File: http.js
  @Software: vscode
  @Description: http封装
*/
// 导入封装好的axios实例
import request from './request'

const http = {
    /**
     * methods: 请求
     * @param url 请求地址 
     * @param params 请求参数
     */
    get(url, params) {
        const config = {
            method: 'get',
            url: url,
            timeout: 10*1000
        }
        if (params) config.params = params
        return request(config)
    },
   
    post(url, data) {
        const config = {
            method: 'post',
            url: url,
            timeout: 1000*10,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' ,'Access-Control-Expose-Headers' : 'Authorization'}
        }
        if (data) config.data = data
        return request(config)
    },
    post1(url, data) {
        const config = {
            method: 'post',
            url: url,
            timeout: 1000*10,
            headers: { 'Content-Type': 'application/json;charset:utf-8' }
        }
        if (data) config.data = data
        return request(config)
    },
    
    put(url, data) {
        const config = {
            method: 'put',
            url: url,
            timeout: 1000*10,
        }
        if (data) config.data = data
        return request(config)
    },
    delete(url, params) {
        const config = {
            method: 'delete',
            timeout: 1000*10,
            url: url,
            Headers: { 'Content-Type': 'application/json;charset:utf-8' }
        }
        if (params) config.data = params
        return request(config)
    }
}
//导出
export default http
